import React from 'react';
import UploadImage from '../../pages/UploadImage';
import { Tooltip } from '@mui/material';
import { AiOutlineClose, AiOutlinePicture } from 'react-icons/ai'



function ProfileAbout({ user, markAsProfile, deleteImage, profileType }) {
    const uids = user?.uid
     console.log("uid",uids)
     const newuid= uids.slice(24, 28)
    return (
      
        <div className="under-common">
            <div className='aboutsec' ><p><b>About me :</b></p> <span>{user?.bio}</span></div> 
            <ul className="data-ul">
                <li><p>Date Of Birth:</p> <span>{user?.DoB}</span></li>
                <li><p>&nbsp;&nbsp;Age:</p> <span>{user?.age}</span></li>
                <li><p>Email:</p> <span>{user?.email}</span></li>
                <li><p>&nbsp;&nbsp;Gender:</p> <span>{user?.gender}</span></li>
                <li><p>Height:</p> <span>{user?.height}</span></li>
                <li><p>&nbsp;&nbsp;Income: Over</p> <span>{user?.income}</span></li>
                <li><p>Marital status:</p> <span>{user?.maritalStatus}</span></li>
                <li><p>&nbsp;&nbsp;Body type:</p> <span>{user?.bodyType}</span></li>
                <li><p>Drinking habit:</p> <span>{user?.drinkingStatus}</span></li>
                <li><p>&nbsp;&nbsp;Eating habit:</p> <span>{user?.eatingStatus}</span></li>
                <li><p>Education:</p> <span>{user?.education}</span></li>
                <li><p>&nbsp;&nbsp;Personality:</p> <span>{user?.personality}</span></li>
                <li><p>Religion:</p> <span>{user?.religion}</span></li>
                <li><p>&nbsp;&nbsp;Sexuality:</p> <span>{user?.sexuality}</span></li>
                <li><p>Smoking status:</p> <span>{user?.smokingStatus}</span></li>
                <li><p> &nbsp;&nbsp;Uid :</p> <span> {newuid} </span></li>
            </ul>
           
            <div className="my-pic-section">

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p className="lead fw-normal mb-0 name-1">My Photos</p>
                    {/* <p className="mb-0"><a href="#!" className="text-muted">Show all</a></p> */}
                </div>
                {profileType === 'myProfile' ?
                    <div className="uploadImage">
                        <UploadImage />
                    </div>
                    : ""}

                <div className="row">
                    {user?.photos ? user.photos.length > 0 ?
                        user.photos.map(item => {
                            return (
                                <div className="col-md-6 col-lg-6 col-sm-4 col-xl-6 my-all-img">
                                    <img src={item.photoUrl} alt="profile-pic" style={{ height: "400px" }} className="w-100 rounded-3" />
                                    {profileType == "myProfile" ? <ul className="image-actions">
                                        <li>
                                            {/* <Tooltip title="Mark as Profile Pic"> */}
                                            <AiOutlinePicture className="main-action" onClick={() => markAsProfile(item)} />
                                            {/* </Tooltip> */}
                                        </li>
                                        <li>
                                            {/* <Tooltip title="Delete"> */}
                                            <AiOutlineClose className="main-action" onClick={() => deleteImage(item)} />
                                            {/* </Tooltip> */}
                                        </li>
                                    </ul> : ""}

                                </div>
                            )
                        })
                        : "" : ""}
                </div>
            </div>
        </div>
    )
}

export default ProfileAbout